/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * ws1.service.ts
 *
 * Service for Workspace one integration
 */

export abstract class Ws1Service {
   public abstract isWS1Mode(): boolean;
   public abstract storeSpId(spID: string): void;
   public abstract redirectToWS1(ws1ServerName: string, windowObject: any): void;
   public abstract isLaunchedFromWS1(): boolean;
   public abstract setWS1Mode(enable: boolean);
   public abstract clearWS1Mode(): void;

   constructor() {}
}
